{
  "source": "https://raw.githubusercontent.com/nvkelso/natural-earth-vector/ca96624a56bd078437bca8184e78163e5039ad19/geojson/ne_110m_admin_0_boundary_lines_land.geojson",
  "sha256": "d42479fd79552cca4eec7f85fcdca717a790d29ff06be7676f1af0568c6d3f7c",
  "scale": "110m",
  "features": [
    {
      "kind": "International boundary (verify)",
      "lines": [
        "ktnmItiv{W{d}AurkBuezBrlDyg{Bd`kI{x}EhvfEsbkCbbyBu`wAdyqDa~nAxrbCs_dBttfBhg~@hacE`dlBz~|D}i_ClolDyotAdjgCcau@nf}DywDzi_Eg`wa@_`@y~sUsg@"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "{pqeEno{iUq`Nq}|EwdTg`wFdee@`hQj}}As|eHrqhCqq|L{_@kwaK_Map{C}qoAcK`AqjqI`gdAiffAvv|@uzbBx{tA{`sBh_eBsw_A`kjB{qo@f~y@a~cB~qy@obaDohyCo`zBswB_u~CdzlA_thCtudC__aBfnqBopbAninBofrB~ugC_~i@nxzA_uu@np{@_jwC~}i@otiCozDodkA"
      ]
    },
    { "kind": "International boundary (verify)", "lines": ["{tyrAdx{dPms[_`Esgp@c}aAgrTctc@a_V|jIs_Koul@"] },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "urvwAnf|qPo{w@ixCoxl@ctUync@vvZse~Ca_}AsQwtyFooaAa_DazJhs^mii@rtTubl@pfgAyd`ApugAiN{ewAm}lBuCwIyiuDxcAmssD"
      ]
    },
    { "kind": "International boundary (verify)", "lines": ["o~}_Bjgx}O`Athy@{l{EqhNsyyCio@"] },
    {
      "kind": "International boundary (verify)",
      "lines": ["{e`wAjyj`PvlOwqx@~}e@oai@bi^m}y@thYwgFsgVsttAv|Lieg@pcTaqYrfmA`rL"]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "iagnA``}sO{_Gav{@srk@mmWov@ct[q`_BzcCsrC}wl@lk@ovg@qbs@idi@jnf@orx@gfWk`SifVs~b@_xt@qdcAkeg@yfB~t@yvQktm@y`X{tDykS|y\\ih`@lyGqbf@uyWedj@gC{ip@ooXuxbAcrYgaZt~Be}aA"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": ["qmeq@bgkyNowe@wgIirf@khO_jb@brFkcVge\\y_\\zrg@qrmAxb@kmPyojA"]
    },
    {
      "kind": "International boundary (verify)",
      "lines": ["knwaAr~q}Ntkh@nwm@o_Lpsx@aeg@|j_@ihOb}|@tmX`|k@cvr@vt_CfcXxl\\"]
    },
    { "kind": "International boundary (verify)", "lines": ["sm|s@pacwMvp[luVj`rB_jl@r`y@nyc@s_Mh}}@z|}A``X"] },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "u`{fAl}jrLlv_@pm|Bxs`Bjpp@~~v@frjAxqgAhww@zjjCp{VveqBndu@naLmycBnxxAm`X`~i@_bj@nsmAolNjhgAjeVhwg@{zE~gOkao@fccAsom@exQedzFh{WwmpBfagD}mhCk{S_}mAnmIstkCugUkinB`q`@eadAbehBndb@nq`Axqj@jakCnhNvw`Cihf@f`y@{ov@fvj@yuEff`Bh~aBj`j@yzeAfhcAg|r@~waEcqz@??"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "bu\\ti`kMbisC_gZz~}Bpx{@bokE~}sEn_lAvziF||hDztvB~wbCl}c@~ioAvlmBasaB`~pAsbTp{mAzpNjvoAgqfA~gDoom@_vv@whpA|cV"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "b_zaAp_kgLrs`@ldmBolUjzwAeugHq`LlbrBhg_Dq`DljkDsdgBlzhAoiJzr`CszrAugh@qyuBzokB{{nDfhpAqub@apr@aoqAxE}jw@}`uByrhB`nRo}bA_zp@}czAudMm|cC}i~Emqd@ga_Dyj\\}dYhdHe_oD"
      ]
    },
    { "kind": "International boundary (verify)", "lines": ["``anInbuwKofDvttBgBddpEwdsLvC"] },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "bse~Hdb|aLyn]nxgD_cYx}vMa{pBd~oAygqCkxBpqK``aCsyeA~xcAcbnE`aPy{tA}ytCa|zBw||@qwaBfuUmveDcpfB}raG{ifA}sqBv}Sa_d@kgtAkqhA|{Sgcf@vqyAi}pAwj_Ay_iAbdwAoi`Ffrl@}vf@cpmAgbmFt~_@}_gEq{l@{fmDges@{{eAy}sBat}Dtjz@{lrDlSqp~B}zrCidbDlpCys}DannByrrDwNwtb@puq@}cpIb~xAa|gEiiwBuc|DzmQ}npDyxdAcevDa|~BmmxBuyhC{skAhmy@{z}@{wg@cndItdE_j_BovsEo|iE_`bAa|o@~uV"
      ]
    },
    { "kind": "International boundary (verify)", "lines": ["`}}mEfprcJgf}BccNcnj@cki@qpaEf|@wwgE}fs@oh{Cixo@"] },
    {
      "kind": "International boundary (verify)",
      "lines": ["leb|C`_llIzjkDz|^rrtCbdpDhk^zmyC_y\\`jzE_dt@p}cEi{gHeh_EeeuAh`[cjkAzchEsgoClsmFmu\\`u~Ccu}HnafJ"]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "nwczB|r_bJ??|qkBewx@bchGl~K~nd@ydmEgge@avnAlzs@a|bCviy@oqc@r~qDodQxdjAsyU~sGeygAmq^gghA~lb@eheA`kjBdBdorBxmYtuoB`je@"
      ]
    },
    {
      "kind": "Disputed (please verify)",
      "lines": ["{dar@jpvkJjvqBvvyCvefAbaPfngAizaAxqc@~no@dj^~dwB`eyAs{Bhwt@b|s@v~rCs~bC"]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "a_rJdzaxIz~Exon@cqO|_kB`}r@do~@fga@|jwAjmGfv|@|fe@vqT{tHzz~AqszAzcwBakyA~cM}vaB~~p@mgeDma^}xcAqdu@kwyAnxk@uq\\nbbAmwtA{kX__l@pml@hsGjpdB"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": ["_pbMvjxkIkkh@f{nB~}R~e{AkjPhymAxpw@bpRnye@kw_@|{f@`rPq~N`eiB"]
    },
    {
      "kind": "International boundary (verify)",
      "lines": ["mwjXdlhzHnvqDbprBnynCh~z@`eiAdziAt}Lno|Aq~u@nsYcdG~tj@t}s@rm{@ihg@hhtA"]
    },
    { "kind": "International boundary (verify)", "lines": ["g_g`@}}s_U`e_BlxGbv{BzjJ}dEzi|AfpaAl_h@}edBd~wA"] },
    { "kind": "International boundary (verify)", "lines": ["k_xgIzoyd@kgg@|rrC|tAbxwBatgBkgg@ysgBjgg@"] },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "og~qAtk_eB{qD_vsE{fm@ibk@ycBm||@hao@eblAd\\gr{@k{_@yk_Ajmw@qmf@zyj@posAamBnzsAsgh@`xrAfbl@pkgAjr@|~a@ljZz|m@ybCxwpD"
      ]
    },
    { "kind": "International boundary (verify)", "lines": ["m}udEgo}wEvlvBrAzhx@vy["] },
    {
      "kind": "International boundary (verify)",
      "lines": ["hkvoDcyzoDj}y@awbAv~}Ad|z@hv~@pe`@fo]hzkBtk}@`|b@jlRf{dAofuChoqCwtzBscgBelkAoyhBwyf@_hzAld{@ogtA"]
    },
    {
      "kind": "International boundary (verify)",
      "lines": ["usxgD|n{s@laL}Azyd@nwBtyfHbQ{eIh``SfwrNghEdpPh_vDzhcBdwn@|`yGi`d@}e@pz{Vvc`Azri@"]
    },
    { "kind": "International boundary (verify)", "lines": ["kvefDnd_t@h{wMwq}U??"] },
    { "kind": "International boundary (verify)", "lines": ["ezexAbbhiAdoxBq}G|ynBgoe@lzu@qbhAxojAiuOdz{@r~G"] },
    {
      "kind": "International boundary (verify)",
      "lines": ["ufykA~zrrAveaAbqBllStkT~u_A_sOl{Xdx]~Hvaj@dx_@||q@}rBxgz@fe~AzyuA"]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "sg}jA`ygeAnofAehJcFa~]c`Ym~q@poEuj_@zqp@_fu@jrNcrrAmgi@}pt@}bYgb~@kjZ{|m@zbDwaf@d|i@wkj@tzt@}gVhypAc`oAtgq@b`g@lp~@|rFyeRkrh@dxU}kWbdy@ljIxhw@_tz@??"
      ]
    },
    { "kind": "International boundary (verify)", "lines": ["}jlh@jcydAsn}@ytm@{xw@sjIc_iBqbwAedzAe|yA"] },
    {
      "kind": "International boundary (verify)",
      "lines": ["yd|m@nhor@txw@p_Hjl}A_pRjwuA|mi@xrt@c}w@|`Le`}@txpAivqAp}kAa}DlmWttQlz_D~~M"]
    },
    {
      "kind": "International boundary (verify)",
      "lines": ["cbo`F_vkr@vfcBttf@beyDy}]ta`D`~l@~|kB`lwBxbrC}ePtjsBmv~Cxgn@}t@lymAelwBpr}IairA??"]
    },
    {
      "kind": "International boundary (verify)",
      "lines": ["gagiE}{beAr_uCh`Jjaw@ne~Ajq}@rc{@ngjAtbeCz{oA}wSvoqAd|Ongl@~g~A"]
    },
    { "kind": "International boundary (verify)", "lines": ["ezt_Ec_rxCbv|AdueA`prAef]xqwBthq@pi|Cqqy@~puT?rfnU???"] },
    {
      "kind": "International boundary (verify)",
      "lines": ["og|sBmn`Yby`MkPrmaCfxiB~iwBnsOf~]nnlDdxO~niGfldAzegAhtFrd|B??"]
    },
    { "kind": "International boundary (verify)", "lines": ["wxbzAafhAft}AjnN|}wAgfYbp~Bs~lBno}AcaEphk@ge`FnwdCplC??"] },
    { "kind": "International boundary (verify)", "lines": ["knn]vylPealA{zGyfgDfusAwp{Ew|q@q`cD{hqAu{tGhyr@"] },
    {
      "kind": "International boundary (verify)",
      "lines": ["e~dc@s`nEwqcAtqj@y{zB|`s@wc`BjoNm|nDodj@wffAr~o@qzxCprQ{ylCmIcvcBpopAo{{@_kM"]
    },
    {
      "kind": "International boundary (verify)",
      "lines": ["i|bbAeunDxyeB~yWzsx@etz@zkcAgybAlz~AolFrfg@}if@np_Mt{GvveCebo@"]
    },
    { "kind": "International boundary (verify)", "lines": ["{`{gAkxcLwex@gq`AeOq_eAtkoBw|sC??"] },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "ckdfA}h`UojmD}pLcwmAs~v@gioB_nZyfi@wzq@ecVw{pEb{gAywbEnwhA{fhAriBmtbBk}n@eq{An}cB_kkFwwCqrbBofrAuerBr|D_oqBqlZmjw@tkJubhBv~w@efvCqdlBevwCvwF{yl@"
      ]
    },
    { "kind": "International boundary (verify)", "lines": ["_{geC}l_`F?|seW?~xtV?~cpW"] },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "mlpjCqssyAfrnH_~n@jxq@qahAtb}@mcBp}aA{gpA`asArni@xikK~fjAb`}FjhIfdwDjcxFxg`GrisAdjgAaipAfs|BbMznCkg|B|~zAdpR??"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "}hovBkxnpCbifWurHusLllgDtynC|dxAdrwBxsr@fsl@gvg@z{z@pe_An{oAacUhlpAtqq@pvfAztRuhJ_rcAhjjAa}g@nmpBedAbqx@axfAzhn@hjA"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": ["}qhl@ugg|Av|dEdfaBvmb@~zm@zkvCdaNjgqAcmRjey@tvNz~dBsh{A|beAetOjxcB_bgA~y}@mixA|axA_vG~qw@krS??"]
    },
    { "kind": "International boundary (verify)", "lines": ["qrxLulycAf`jFau@g_Alc{GjhJz{`A"] },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "oxyL_{xnAfetAleMl|cByqu@e|NcipChye@ewo@leaFvpsAdorBwk{AtnwCkhTnz`CxsWhh{Ax|z@ueGjlkDwx|ArjgBdquAbpNh|VjxbCtbp@b~aAvc`CqshAtxjBfusC"
      ]
    },
    { "kind": "International boundary (verify)", "lines": ["u{yLkov`BkwtDckeBeofB_lsB`y_@mecCv{Iwr|B"] },
    { "kind": "International boundary (verify)", "lines": ["_g_cAatpjCpqrAscUpbyBssoBfunAiQ~gpAlv^hu{@wpKzfw@mvbA??"] },
    {
      "kind": "International boundary (verify)",
      "lines": ["ey_wAmcj}Ehyg@skbFqwpC{~{@ftwA_puBy|l@gpqBvyg@sbn@xiAg|dC|hmAu~hDdmbAgoq@vv}@}quAboqB_ioAne~@iwaA??"]
    },
    { "kind": "International boundary (verify)", "lines": ["yt}dA_yifGzogBx}fA??"] },
    { "kind": "International boundary (verify)", "lines": ["b~dGufpsDn|Rwgn@ah{@}usB??"] },
    { "kind": "International boundary (verify)", "lines": ["pr|EkftxDvemBqplAz{qBlhJfvWbkw@"] },
    {
      "kind": "International boundary (verify)",
      "lines": ["vcuaAkj}pChs{@isS`v}AveUnrzAkia@|chAbb\\llbAqsOumAxtuKpmlR|~Gnx~CqwbCf_yBom~B"]
    },
    { "kind": "International boundary (verify)", "lines": ["rn}iBaeulCokk@o|~CxfJat}Br_k@ialAreOym@x~Jb_]"] },
    {
      "kind": "International boundary (verify)",
      "lines": ["hmdbD}~vbEtvuAtwf@zaTzhqB}zhBbqsB}obApy@sihAuit@wzw@emQk|Lqmw@twb@ypaB"]
    },
    {
      "kind": "International boundary (verify)",
      "lines": ["jdgkBoleyCxc{C{djAxya@qhf@z_pBal|@`puEa`|Eh_TosrAl{cAyNrzzBgmx@d~\\_`vChgwAqo{B??"]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "vzs}Aa}wwDrzgAqsKm{B_|aD`fh@qoyAlio@{ai@|dMo_|Afw}@emdBjevFyLpjfCnae@l}pC~jGnzx@kk^h~qBbaUzwPzn\\lzkC`or@zt|E|wlE"
      ]
    },
    { "kind": "International boundary (verify)", "lines": ["vafbDickgEms@jcsC"] },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "qxr~Ftrcv@esp@c{eAcn[kunA|r~A{}o@oFujrBgtW}l`@pyE_ypBz}`B}qu@|zs@tfyAlkwCtoAnq[`v^~h{A~yFraOjksAxatB_gmAji_Cl|t@bay@_jbA`bt@vxYrfhAdkgAnt_AchO"
      ]
    },
    { "kind": "International boundary (verify)", "lines": ["gofbGiefQbiX~kaFcjwAjwzE`fi@b_fAkwwAdpfJ}|jA`zlA"] },
    { "kind": "International boundary (verify)", "lines": ["i{qnI{zp{@jv\\b~{BewX|rrC"] },
    { "kind": "International boundary (verify)", "lines": ["}{{lHigwd@vcr@sd{A`~b@qmxGxvdC|vaBtcjCfxW??"] },
    {
      "kind": "International boundary (verify)",
      "lines": ["klbgI{vduAdkbBgsl@dcs@rmu@trdAu|eA`ngBaio@xibA`fNtu{B{`oA??"]
    },
    { "kind": "International boundary (verify)", "lines": ["ufaaH}zpy@fta@{pFxxn@|z\\`qb@ckwAzhD}sbB"] },
    { "kind": "International boundary (verify)", "lines": ["u{e}G}qv~@vwZqiuB_dd@wuUg}`@o_`E||bAksj@dmq@khvG"] },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "cbekI_~~vBxdUopoF{|AycfJp{SudcBnd{@w{m@|kuAinGfhiAwdu@pzlAxb@xzf@bctBvnyAag{@j}uAgvBroiDefaBhxu@d}SjvUp|_BfmaDnjpDrwvAkkq@skJ~ri@gajAvrxDdrZ~qkCu`Sxe{Apzh@lkrBgfdAboaBdoYphoAixJt_Jsd_Bp{xAmxJrepCyc|@zoQczTl}dC`mq@xc\\alg@hbiBmvt@}dKw~O~_qCc{}@jq{A"
      ]
    },
    { "kind": "International boundary (verify)", "lines": ["_xv_JgrksCmoa@mjeDh}VwqtAvngAybgDrJ{``D??"] },
    { "kind": "International boundary (verify)", "lines": ["ah_jJ_axiDzaa@cl\\rpoBd~iCbduDm|x@t~|@furA"] },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "cpyuIig~jDh~o@gslEtno@ovZ}hV{neBfqm@e}}DbuzA}bRbus@jzh@`{~BkmyB`sb@innAtgb@zvJzja@kubChas@ogw@~ui@|~jA{wEdr|C|fQtqd@ny_Amzl@na|Bi`o@??"
      ]
    },
    { "kind": "International boundary (verify)", "lines": ["qvleIetci@f`aAgoc@ryqDpto@nohAdop@rApitBbtkE_y_@"] },
    { "kind": "International boundary (verify)", "lines": ["mrauHcnqd@b~bC`eU"] },
    { "kind": "International boundary (verify)", "lines": ["is}pHah{c@hbk@}~e@`stAt_J??"] },
    { "kind": "International boundary (verify)", "lines": ["okzoIw~x`Cxea@mpkEb_^wiuAlnt@`zS|yp@msN"] },
    { "kind": "International boundary (verify)", "lines": ["iq~tIumo_C_|z@mu~E|oK{pfI{hRk{~Dxrg@qkZrpKu|fBlw}A_wzD"] },
    {
      "kind": "International boundary (verify)",
      "lines": ["mfbmHcgarBtFjfy@~cb@vg]znGjyk@zlk@jxKzgHzkd@fdQvgDzeSjuaAgiBvouAd~i@rtZ"]
    },
    { "kind": "International boundary (verify)", "lines": ["arrgH{pofBpxWztNrtbAymR"] },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "cnpfHarxeCdct@{lkBhjs@{rLz}g@hhvBxmcC|l{AnmcChauBxyc@~q{CusGb|xBxir@vstCxd\\~~gA{pd@pi`DkwrA~~pCq`Wr`}@u|`At}d@edAfz_@"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "_{gbGooroBoe`@onTa}hAzzkDerpAjvhAmfj@tmiAq}gAhxxAyo{@zii@oizAds~A}`pAe{g@hzk@qaeA_pg@{ii@iiC_gzApl_@y{fDmuAs`fClfj@oiwA"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "{`rjHo{thC~yq@jdu@vvmA`ce@h~Rrth@gjz@hdpEf|Jh__An}l@xxl@pkW|uzAwnKpbThi]vb~AfxDfrlAzef@hvNz|V~|bDqhTb_gAc_q@fkbB"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": ["owyzGeibdBb{r@tnzCx{mAj~Qx~Rl{bApqu@kV_xBxskAi{^vlaAz}_@twb@ktEtbgC"]
    },
    {
      "kind": "International boundary (verify)",
      "lines": ["sbieHwanaDb`Rgpz@b|x@sn{@ljqAa~|@pcsButoBbvtAsfErkrAzrS|bxAm~a@"]
    },
    {
      "kind": "International boundary (verify)",
      "lines": ["wrwiG_whmDeoStyqB__fAncmC`ll@t|dFdyp@`z_BygIry}Gym]rauCvhMntjAuhoAhew@??"]
    },
    {
      "kind": "International boundary (verify)",
      "lines": ["gs~lG_fhiC~hk@vdo@tifAsoPthsAy{}Aba|@vmiAtc}@dz_@pfVmdT|pZxb_@fD`rC"]
    },
    {
      "kind": "International boundary (verify)",
      "lines": ["s~fcHysriCmyh@cisAbsTezwBdVqe|Bdvn@utyAq~\\auaAuwQsdoCssl@{bp@XykqA"]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "ob_}Hie_aEt{Fe}gAslk@}ip@byHaiz@}zQwoiExqmBey{Bfpf@`xo@bs{@udOrmHuvzChusAendArle@bgCptcAs`wF{|]uztC|mzAkpwBobAicqBxp~@u{~G`jx@mhArgeBjinAhujBadj@fc`Ajv]diMf_|D`pu@ptcBjwuAddE"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": ["aqk_Gqb{iDgeYjdgDfm|@p}eEng`BhcA`mQxopD{fcAnrhCrtt@nj{CysD`noC_d`CxzL_u}@fy`B"]
    },
    { "kind": "International boundary (verify)", "lines": ["qyh{Fm{akCpnEjfd@l`a@xb_@axBdzhBbui@vmiAjhP~v~B"] },
    { "kind": "International boundary (verify)", "lines": ["aih~Fs~k~Cvur@oc~AvfyBxm{@v{Ttlm@"] },
    { "kind": "International boundary (verify)", "lines": ["cbhxFinh_Cbir@h|Bfi[fn~@fn~@~uJfv}AfyyA"] },
    { "kind": "International boundary (verify)", "lines": ["ylo|F}_s|FahHmboE~{~Awb{D"] },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "wkbhGwuzrFaaVcyVjk`@yadDpr^ip~Grs|A{|hGvhc@efa@ot]cmuBtzg@}cuDpcoAkxz@ngl@swyBv|Yjuq@`uhBke_Bt{UzrYorJ~ghBidw@fppCv{^~yn@"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": ["}epdLqjomD|vgCjo[tcaCwbjHpgrCtfsDji}EadbFdmfDpnbCjjpCsynDtg~BdznAbydCmb`HlrbBpmhAjyoBrltDdixF|daL"]
    },
    { "kind": "International boundary (verify)", "lines": ["i{c_Emt`wE~siAknC~fwHpi`B"] },
    { "kind": "International boundary (verify)", "lines": ["wgvjEeswkFnylFuvmA??"] },
    { "kind": "International boundary (verify)", "lines": ["ys}uDy_ycHkgOnfbChozDzinC??"] },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "matuD{|lgHkteBzakBi`gBv|@v@jk}@anlCq__@wlsCxncB{`jBhinFwsxD|gfC_lwCmgl@albA}haBwaqBrvMgsy@ja_Cm~gFpp}B"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": ["gl`bFypbhIoxd@esjD_tnBo|iCftDwraCekc@{vtA~~Pc{iCh_bBq}vEdjTg~zC|}kDif~Ev~E{qpCnjcDgcP"]
    },
    { "kind": "International boundary (verify)", "lines": ["edsdBswccIsmgC`w~@eiaIpwwC??"] },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "m}wbB{ibdGuh}@awtAsiqAf`Se__Biwr@~wq@}eoAysPi}s@qnC}k`F~oRyxb@~oRux{DowHyziAhb`Aoyo@up_@uczAoalEc~jCo{vAkhuDyziAycrP"
      ]
    },
    { "kind": "International boundary (verify)", "lines": ["aixdL}i_}Bvq~AwicGf~cCc{oHrwkH{cDd_kAk|`A"] },
    { "kind": "International boundary (verify)", "lines": ["eqgmDwgofHjaDrciC}`|Ahso@czQj`mD"] },
    { "kind": "International boundary (verify)", "lines": ["c`iuC}_txH~zLfcu@awe@l`z@"] },
    { "kind": "International boundary (verify)", "lines": ["s}_~CwifuIhqaAwcd@"] },
    {
      "kind": "International boundary (verify)",
      "lines": ["sbcwCi_fwIlWjvbBbe~Bd`ObdZ_ra@|me@~kwAnynAhPzyoA~{w@psmAjbD??"]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "yjezGgaujHuq^lebBeocBgyR{naCfo{BnmDp|oConcC|wdD{_sCkvoBqyf@j`x@yquEazzCpgpBezgEysmCciWylsEydrKy`DebpHvffC{nmLf_nAigfFqkqAofnEo|BkstHtedBmxxFu}x@}vw@tlGwiqGao{A_}o@oieCvn{Hqc~AcmzDyet@fqc@_xq@_ozDixdCb_lCwsaA{pxA{}bAazyU{fo@ck~AebgAyugN{_pAirnD~ai@w~}IvliEco|@}on@{{jEnraAqzyFhriBxdOqcJqizD}hwDiohNhf|@zmfAz{uCcdxFx_oNqmsLogeBuagB|ooBk`lGceq@mtwGrcb@uyjBlzoB__}Ad|d@{pgCx{qAucrAkcYmqzF~mvBqsfB"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "mb~`GmybpLdfRu~x@fo}Bb|bDrohAsboCguo@objC~{eBkofF`tkCnbyFufRbqsCl`DbsoAkhu@d~ZcqyAwug@jkl@|cdGni|Bva}@l}jB`y{A_eHpabD`_uA`sq@drm@einCjlpC_ei@btdErwlB??"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": ["il`cFk|~tK_aExyy@afs@fc{AtodAlr]zwd@rrcDhe{Cr~e@xkz@ramBjm\\ndyC~nwAfxg@r`YpgrCibiAdefE"]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "g{uaFo`_}KxxVytz@wv}@eklCnvd@gx`AolxAy~}@x`C_wsBku[qa]ewmAusSi}bAwasAdlk@ivhBbuz@tfTvgHwaz@zacDpeQx}~@milAi`h@q`cAkkRguuAcmvAsuxBpkM_oeCvHwlhE"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": ["onnaG_xzhNxck@nmZtxhBlwrHxolA`sdAteVbpyFvu{BbzhAeeYxvmEvee@t}eCzg{AdmyDhul@}{Yttk@zqv@"]
    },
    { "kind": "International boundary (verify)", "lines": ["iltoFcvt`MzvsDgop@etRae_Axmk@yruBh}jAvxEninBoh\\"] },
    { "kind": "Line of control (please verify)", "lines": ["sk~fEiileMdm_Bes|CbFnI"] },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "}ynkDse`qQd`iAsvMryb@fncArdwBm_Ocib@pqjCx}eCdz{FpwnBw|DpybDdxjBld~Af{Hd``DtavA}nk@xswCdciExqFhoaAtck@b}qAatSrim@pj_B"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": ["msciDy_zxOsaRhvbFixk@p|{E}wtAdp}C}ne@pwvCey|Atp`A{_[pvlBeg~B`edEm`{@nq{Cbvm@d~oA"]
    },
    { "kind": "International boundary (verify)", "lines": ["w{reDcpa}OoepCoe`Copp@mnhBzel@qqjC`wCkefBjos@gotA"] },
    { "kind": "International boundary (verify)", "lines": ["}gd}BivwrP{c|CzvKnq\\edcAmakC{~B"] },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "}ynkDse`qQsoMcfqBh~qBch`Abqm@_gtA|mtCuvDhb`DvzF`bbD`_xDbufFdlV{k_@gdmEnxrDmqm@pyd@wtzB~faDdzw@bihA}_pCp}b@qqsAuzw@egnC~voAmzD??"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "qzr{Bu{`bRzg{@ypsApjtByeJ~|Gk~bCfxlE~`o@vanDorCyosBszlE`ma@wny@wsDokqBs}bAajf@flL}urCrr}CsosCvw_EaeKbfiDqc}CzhdDhvG~_wAtq~@??}_[lavDvhd@fp{FvkaDba|BxzjFkgm@"
      ]
    },
    { "kind": "International boundary (verify)", "lines": ["oyyaC}uphRd{l@sqPniDacgB{k~Ero\\_s[kgdB"] },
    {
      "kind": "International boundary (verify)",
      "lines": ["e|tuAaelnS~faCwgl@r`iFn`W|huCphgIhiuBowtAddMv_lEftmAv`hD"]
    },
    {
      "kind": "International boundary (verify)",
      "lines": ["usbhCkdrnRitn@gxgBp^wwzCgpU}{|DuagBkneDxghAkc}Ajtb@ypqDlooBj{]jjnAy~{A`uq@oscE"]
    },
    { "kind": "International boundary (verify)", "lines": ["ed~d@kmlnRtfoA|y~@jiVr|_CihcB`kNgptAhj~Crya@l}`@"] },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "ubgXoynnUo|_@jhhD{A|p_Fjc}E`tbAj|bAjejAnsnGhccBbsh@xg~Covu@|wwD|bP|s|ApwaBdypBmaM|t{Bbvf@z~|BijmBzpdCepaCnr_@"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "oj{kHq|qvOmz`@a|lEyegDutsJ{zzAoahH`}z@oyhDf{A_xjElfzAqpaCt_Fw|aEjbp@{jyGc_gCyy|D{}qBnhnAiliEihiEpvoA{xyEf{UkhpDxdq@esdFnjqCwfd@tcqAantGmec@oqwD}oXmavFjvX{vbEpz|A_h~DxybBupuBa`AmbtDpx^c_uFyko@iprDaj_@ac`GqshCwa}GdbTqbtBjm`AqgeBehOu_hF"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": ["cpurFksmuVeg|Bk`~Cq~gB}fvEsoiC_eeCze|@ev{AhbFa{gD}_fBpo]}bsAsslHqmlByslA~hrBec}B"]
    },
    { "kind": "Line of control (please verify)", "lines": ["qmtjFshknWrfn@zb[rzKhcrArmHl`iC|cwAxakAs}EzdvAvuPbfK"] },
    { "kind": "International boundary (verify)", "lines": ["xzgu@i}vyVtoe@exRxez@{rB"] },
    { "kind": "International boundary (verify)", "lines": ["~yzNibr{Yzn{RihB|n{R}gB"] },
    { "kind": "International boundary (verify)", "lines": ["f~v]kcvgAmisA{ymAcz_@o_z@h_bAgehA"] },
    { "kind": "International boundary (verify)", "lines": ["mwxpGg__sBiP}xeAp|tAb|o@vbjAmd}AvzzA~m[tsGv~l@"] },
    { "kind": "International boundary (verify)", "lines": ["oxd~FicpgHbvmAxrsB`up@ro`@ajLpkuAesuBjfeCupEx{u@"] },
    { "kind": "International boundary (verify)", "lines": ["wmfbFyknaGb{xB`bcBbgo@~{iBltmCelQ|bkFjxhAjgjEjkoL??"] },
    { "kind": "Disputed (please verify)", "lines": ["}nbjEuhsyEfqAxks@??"] },
    {
      "kind": "Line of control (please verify)",
      "lines": ["ehnuEs|wfEfeIutc@ctOi_t@b`Aitd@`~JqaMtvRk{BsnFuvHdaCsf\\kxMaid@hzE{|S"]
    },
    { "kind": "International boundary (verify)", "lines": ["_wshGwrhtBdo`@qyr@t`Zep[j`Tqd_A~og@umiA`wOz`O"] },
    {
      "kind": "International boundary (verify)",
      "lines": ["ygwzF_unqGfir@ulg@vx`@ikiAn~o@`hf@x~aAo`gBne}@|`v@zbt@g|qAd__@euvAtmfC{iC??"]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "_iajH~dwlV?_uiP?}ybQ?}~~D?cjrQ?od_Q?_}hQZ{giQ[cvvSkC_f{SjCifsKq`jAsQ_]ubaApfjB{ta@z``@{u{@f_KekgCjb^mkfEnp{@om|DokXoe}C~wq@ofoFi|@g{~@mhv@qwmDf{eAogvDrojAg~}D~``Aec}Czo}@wrvCrjr@g|QbfRy~l@fjRd}Jt_Egks@seSc_e@`gm@eyHp}]ygf@?mst@~zVcs[fva@raWptzA_ojE~fpDish@tuhDwaf@hmrBfbx@nljBnxzAnjcA~}i@~jSnhC~{Ze|Tpx]gjaA?q~o@_hgBqzaFiu]kfhEyc`Bqn~FuxR_xBgqz@nqPcje@lq^e_^edwAyW}z~Dv@sgrDobkAeo}@qeNglW{skC}kmEe}b@acwAcj@yugHcDi|fJoeo@kpR_yHcp}@gf]c~qAwzwAwidA}}vCmqz@}krCe~sCjir@k{_Asd`@_~aCbjw@{uuAdiiGnD~kmBav~B"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": ["khzlB_~liFfnnB`zaBlb_@fznCf{z@jo|@hy`CngRp~}GtbsAjemAiwS??"]
    },
    { "kind": "Indefinite (please verify)", "lines": ["wazo@{ztbHreiQj|fPlrG`m}F|thC~`mDlrBre|Bbq|@plt@"] },
    {
      "kind": "International boundary (verify)",
      "lines": ["el|Vgym~Fc@nmdCa_aAvwmA|tpArlqDpkpAfvx@wjN|faCyoUpfj@fkDpvl@c~@jv|@yzdDjfvF?`}fC}g_AdvaA"]
    },
    { "kind": "International boundary (verify)", "lines": ["xlp[{tgnFyfbEviwGyhpBhiLi{lK|ecUkmTt~_@"] },
    {
      "kind": "Line of control (please verify)",
      "lines": [
        "usxgD|n{s@?nv\\hsgBmnCjhEnvwB`mk@j}}@?~twAsjXnteAd~S`icDxewClr~@rhMj`|@tfuFvyzAlwqElonGhulGzm_ArvvAj_oAbkeAvmVdrN`zvL"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "ajffJaxhbAmpoBmbuAs{dC}oaDyrdFir_Ak~aBjy{BujbGj_KaevDqy}B`jB_w`E}klA{}bA_vaAjcfAwwqGqgnHoowEsjbE{}iCi}_CbTupzDkwkBkur@fh^mboJao_Css[}_GgdxB??"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": ["z`~}@uiauFrfpBlkzC|yjA|ptEqeBpdtBzqy@frdAd`D|}fCztWv~q@e`v@huiFnxNp}qC"]
    },
    {
      "kind": "International boundary (verify)",
      "lines": ["hziw@ai}fEbcvAce{AjxdDmtp@p|s@~g`@ti}Cjgf@ny`Duod@p~bAnm|@bmtDjhz@~qq@queB??"]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "~~heA__}qE~lsC~tu@~{|F_uu@azAqxbA`~}@eneAzflC{xpAhczFyrOlch@dpsAnofC|rz@}swBfm~BythCpmMuxyA}ah@qgmAviJolp@nblAj}Ppvt@wv|A~loB"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": ["iklTqfe{D~jcFhyJjmYihmAdjdAhx}@|zr@b`jAhzdBptiAvxyA|ah@zw{Cv~I|riAzfl@`grChs@"]
    },
    {
      "kind": "International boundary (verify)",
      "lines": ["lmvMkb~xDd|kAoiJvgk@}`i@fn~@ux@~zg@zdo@rzdBr_kAdweAnzeAphHnwoA"]
    },
    {
      "kind": "International boundary (verify)",
      "lines": ["uzhdG{pszBs`Mavm@cz_Ai_Z{xIg`b@|pZuvZ`dKaoc@ja^qpX~dHyb_@rec@w}d@qa@uvZvpn@x{TpfVnjV|sMgoE"]
    },
    { "kind": "International boundary (verify)", "lines": ["glcmB|ottLy`t@s_Cqsy@rgq@k|_@wrn@qajAu|MujiBxaP"] },
    { "kind": "Disputed (please verify)", "lines": ["kssdAiewiHdeBve@rmoA~Td`dEr@|{dBRf}vBddwAl_bDfegC"] },
    { "kind": "International boundary (verify)", "lines": ["brhjBb{vgLdccBbjs@pzp@hlcB"] },
    { "kind": "International boundary (verify)", "lines": ["i~`sDgyctEupnIfj_C"] },
    { "kind": "International boundary (verify)", "lines": ["oosfEqp_yEjz{@vs`@"] },
    { "kind": "International boundary (verify)", "lines": ["ixcjEg{syEishBcjn@qrhAgoiB}qkAn}^s}H`zvA"] },
    { "kind": "Disputed (please verify)", "lines": ["ctvdEy{}wEtUpKy`ZpseAbaaC~zg@p|Teap@rzYb{p@|lr@hlGynYmyzAni@qA"] },
    { "kind": "Line of control (please verify)", "lines": ["aztfE_y{xEsu\\qnYg}nAz~Akh@qQ"] },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "myry@yf_pDg{c@{qcBa_x@ybSqfg@owhA`_qBohcDwbS{qcBmykCsf`BohjBmhjBijtBnwOa_x@b}m@{`IkjtB{qj@elLdlL_pyAvdoC`nVlykCanVxblA{qcBz`bAanVrf`BhjBpzBe`Z"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": ["iprs@slxpCidy@g`~BkjmDmhq@_pyAust@kyYmykCvst@_p`@`_qB{qcBnwOwst@_p`@eleAruEmykC"]
    },
    { "kind": "International boundary (verify)", "lines": ["y`}XgrpnEhyxAvbwBqMjlhCzul@`f|Cutj@he{Bpgt@dloA??"] },
    { "kind": "Disputed (please verify)", "lines": ["myry@uf{hDpfg@kyY?enaEqfg@quE"] },
    { "kind": "Disputed (please verify)", "lines": ["a_d\\arryE{rlB?qw_@nmdB"] },
    { "kind": "International boundary (verify)", "lines": ["lhdz@gadnEg_u@~gf@{lc@dn~D"] },
    { "kind": "Disputed (please verify)", "lines": ["b_ieA}~|qEcshG|tu@qazAvfaA"] },
    { "kind": "International boundary (verify)", "lines": ["qysuEzxfLbb|BurhAfxuBasJ`emE{mbA`oh@}mr@`|jA|xb@"] },
    {
      "kind": "Indefinite (please verify)",
      "lines": ["_j|cEfm~Fj|_@rr~FnfgAhjwA|_Pr~oBdroCjkGphlApjcFtx`BpuiArns@rz~Czw\\d`bEbcoC`lzHllfFgt@"]
    },
    { "kind": "International boundary (verify)", "lines": ["opsaFshviM|`zAaioC??"] },
    { "kind": "International boundary (verify)", "lines": ["udokEix_`Nr}bBgulA"] },
    { "kind": "Disputed (please verify)", "lines": ["slswEcsazMp|cFs|pEji~ClwR"] },
    {
      "kind": "Disputed (please verify)",
      "lines": ["mdohDgotnPamWgo|CsgpCwwpD}j{Bgc`Fx~n@qybDwfqAmfjClmxBuqzAr_qA~}`A~d\\mrqE"]
    },
    { "kind": "International boundary (verify)", "lines": ["esmc@prx{IlunDte^x}q@`quB|`m@aqIrwcB``c@vylCopuA"] },
    { "kind": "International boundary (verify)", "lines": ["micb@vtihIt|fDttdB~rdCkmNlvrBwtkAd`sAnca@"] },
    { "kind": "Disputed (please verify)", "lines": ["shjSxhq~IjFyo}@jgmB{sXxxhD}gvB"] },
    { "kind": "Disputed (please verify)", "lines": ["c_nRxjuiIrixAxdPncqAbyp@"] },
    {
      "kind": "International boundary (verify)",
      "lines": ["}cuaAezadGhedA|qi@npjBocgAb`}Am`gArudA_qiAzwfF}q}Rge@wgcD"]
    },
    { "kind": "International boundary (verify)", "lines": ["el|Vgym~F|p|EtuiDpnfUuiA~b`DysrB"] },
    { "kind": "Indeterminant frontier", "lines": ["slswEcsazMniuAtuiB??"] },
    { "kind": "Disputed (please verify)", "lines": ["o{qwG}makEyjo@umr@`{h@kziCxuFcy}@hqe@ajXh}D}m\\"] },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "iv}cE_sijMhwoBbfeDbfjCu_Bf~bEzq|DveeEhmyBnwkExhkEczMrxaFlvkE~fvEvuvA}y~BjiuCggUp`bBcvlB`ufDexe@iOdylLxhaCdaaC"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "k{v^xeuqJtE}Drbv@qzXdpiAvlfArbhAxmyEth]nmkCndm@bkw@eyo@thzCy~W|qoCd~Pjrc@hsq@mlvAb}aC`{Ff_zBsbZ|wOomdDp`h@aqIjqv@lojC|uqAduUx`_@hloAbrl@bgpCnwz@rxd@|sKlzvCohfB|ojB"
      ]
    },
    { "kind": "International boundary (verify)", "lines": ["gmkqFmykpG??wgDasg@pks@azx@aMmhuAfc]~[v~oBqvnA"] },
    { "kind": "International boundary (verify)", "lines": ["gkskFyczzGvvDfveA"] },
    { "kind": "International boundary (verify)", "lines": ["ygwzF_unqG|m]zlnG"] },
    { "kind": "International boundary (verify)", "lines": ["{xxyFcg_iGrvcA}d`@l`~AlxQppo@kfpC~_x@m}kA??"] },
    { "kind": "International boundary (verify)", "lines": ["gmkqFmykpGhsv@tvdC~~~Ec~{@ln{@~ee@dn{CiyiB"] },
    { "kind": "International boundary (verify)", "lines": ["izzaFetgpG??|~_@`r|Aawp@`rcAoeXtdbFdj]p{rA??"] },
    {
      "kind": "International boundary (verify)",
      "lines": ["wmfbFyknaG~j]`d}EuhBzfhBbhhA|v_FnRzt_Dwwc@t|fBpiu@d`vEo~d@l|~@l}kB~pIdxi@zhs@dxi@zhs@"]
    },
    { "kind": "International boundary (verify)", "lines": ["wgvjEeswkF|coEhn}JuklAhrxEqi@pvB"] },
    {
      "kind": "International boundary (verify)",
      "lines": ["gmhcE{jfnFlm\\nfd@f_aBvcfKlhbEataEld`@vq_A`l`Ajc_@p`Zl`tCfieAnvm@jb{@rlsAca^xjxE"]
    },
    { "kind": "International boundary (verify)", "lines": ["{krpDmmf{GcrN`cjJoxgKzteP_vgCn_bHw|s@bgjF"] },
    { "kind": "International boundary (verify)", "lines": ["_}}rB_gk|H_ibE_}hQ_seKseaCajiCpoxA"] },
    { "kind": "International boundary (verify)", "lines": ["afriCa{}oIbhh@jjf@gnaBdcjQuzdEvxiAodl@vmF"] },
    {
      "kind": "International boundary (verify)",
      "lines": ["_|qxEofrtJljrFnrnAvbmCltt@py[o_tAh}iBporAv|zCg~~@t~zBqhNp|_@i|rCzu|Bc_OfapDvcpD"]
    },
    {
      "kind": "International boundary (verify)",
      "lines": ["y_auD_oprJ??jveB_u_Bp}tB_smA`{tA{uyDn_kDskDxr^mm|Ab}xAcdOp{cBnvxGx{aFzqhA"]
    },
    { "kind": "International boundary (verify)", "lines": ["g{uaFo`_}Ksfh@|hrCmh@dykB??"] },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "il`cFk|~tKsovB{jD{qrAfxbGys~A~fkEy}zAfk~Bk{eCtk~EojhEb__Bqmb@`p`Av~GrdrEa_g@jviAazzCf{S{efBjdfGfnpBppcDdhbAjzeDfkaBia_@ltAjj{E"
      ]
    },
    { "kind": "International boundary (verify)", "lines": ["_rkcF_pshM??n`w@swa@??"] },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "opsaFshviMf|TfupBdac@`hbB`uUhc_Fx_h@xupEhatAj`qBzwqAodm@nc`BmiUp`qA|g`Bd`jA_dGlieAnut@mbEnxxD~e`CqwkAjlp@vh{Bh{tBz|qAhhtBexIr|u@jkkAceQxegAzmXhgtCvsu@fjT_JblpClpmB|zkBpeeDxyEjepAjy|F_dPt_gCdyi@dpf@a|W`wsB`g\\jkbEwvbBrgfI"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": ["iltoFcvt`Mts\\zgpJul~@`ipFncNrwrEgroB}nQpu_@yqsEwg{@qofA"]
    },
    {
      "kind": "International boundary (verify)",
      "lines": ["whkkH_oetOl`aCptsCvfQ~eaDlzbEhiHbhwAjskBug_AxmbK|t|Ip|kCjnj@f~bBv_mA|{aKdhrIkxnD~yq@x~dC|inBgrN??"]
    },
    {
      "kind": "International boundary (verify)",
      "lines": ["onnaG_xzhNws[dkwBieeA`}`BwlStx`HwiD~ybIfoT`~eAwbqApcuG`mg@hzmBzhrBfk]chbA`i`I|pZpq_CjqtAxvj@"]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "mb~`GmybpL??dbc@n~nBtcgCjr`GjwjCnmtArf@twgAko{Axot@wiEtkwFa__Dfvf@wj@rd~A{{bEqqM_tmClyhFjfN|}mI|l[d_dFk`oDloyD{zhApy~CuyjCnvmHo}O~nc@llrBrwuN`doUktF??"
      ]
    },
    { "kind": "International boundary (verify)", "lines": ["_bc{FghrtIxoHbecBscxCdugCyuu@n_cChsg@pu|En~_AnhuA"] },
    { "kind": "Indefinite (please verify)", "lines": ["utlyE_xxrM`gx@czgF"] },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "yefwDe`anNfrwAp|zBduuDzyjAt{hAwe|Djy~AocwDbqlBkv}F`iXovjGljbBssoB`rQ_|uCvol@k~iFqgBssaDuhlAekUgb{BhvXacsAmbN"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": ["w{reDcpa}Ofcf@odCdciAyopD}o]mxyBdbLs{cDkxDuj~Ck~vB_vLsi}@|nnA"]
    },
    { "kind": "International boundary (verify)", "lines": ["msciDy_zxO??sah@qbvB??hyxCwkO??"] },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "w|oeCocstPaytHtzeBpRt|t@hy{Br|^afdB~|iBadnByh{@_hJ_kvAihdD_ayAaj`@zroBt{AdctDexY~yxD{xfC`fPesHtf|AwksAjuyChocC~~cArkfB}}kCxwgAfbyBrdfAfjj@vis@afwB~ttBpf`@~zqCytbAny_D}k]"
      ]
    },
    { "kind": "International boundary (verify)", "lines": ["oyyaC}uphRh`~BvdeDr|fAnsh@??"] },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "qzr{Bu{`bRjdl@dznB`usAp~pBxvGb{hC~crEx`xAjnb@rkqAfkjDck}AdrmCk}zB`|_C__oAjxhDnnfA|ac@zlbAn~`Besm@tdzCsgaCz_lBshUhvyAv`B|bqDkjkAlauDlgjBjugEls}A"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "usbhCkdrnR??`fyCscqBpmpDauvA~o@ymoFliiDqujAldr@hz{BzeeA~_w@vysB{~hFjxeFgjaDhakDwazBl{fCkxrCz}hC{dp@jgbEdob@??"
      ]
    },
    { "kind": "International boundary (verify)", "lines": ["e|tuAaelnS}{fAzblDhteCnjwAyqkAjd`D"] },
    { "kind": "International boundary (verify)", "lines": ["wgwaG_sj|Wvda@_jZ"] },
    { "kind": "International boundary (verify)", "lines": ["wnx}IcvpeDf~k@sb}Axu}AysOpgrBww}@??"] },
    { "kind": "International boundary (verify)", "lines": ["cpyuIig~jDnjjAxxpEfz_@zwuB"] },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "ob_}Hie_aEzqJ|sfD~zi@rd{@xhaBhqKa{QztlAljHdgoDktl@der@t`a@bhhAif[zlhAk|BbyxC{zm@v~xE_iNlhdEtiCzhvC~|s@d`jBprFrj|A"
      ]
    },
    { "kind": "International boundary (verify)", "lines": ["kimrIstu`D??pnvAgjQhp}@dc_DhgmBjil@rqhAr`sEqi@|w{D"] },
    {
      "kind": "International boundary (verify)",
      "lines": ["aixdL}i_}Birr@}`tBngfBq`xEktHm`~Flen@cupE_muAsfyDeenC{w~AeeaAignHrtlAksyFr`hCrvqA??"]
    },
    { "kind": "International boundary (verify)", "lines": ["}epdLqjomDy~Psv|CmjmAqikI"] },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "sbieHwanaD??ux[qqm@giRky`Chz{@k}nCvhF_joArps@sfwA`eaAv_Mh}^ucfAxspAkf[xsp@gecAnb\\fxLtxR_lc@dmM~tr@{uDnbrBc`Z~fRvqNvyg@|}a@ayLxg}@xmt@h_bA`ca@~eTjdp@"
      ]
    },
    { "kind": "International boundary (verify)", "lines": ["ulstGqjikD??n~b@advAql^axzAno`@uqwA"] },
    {
      "kind": "International boundary (verify)",
      "lines": ["gs~lG_fhiCm`a@rwb@{}_@igl@eiWvdo@twj@fi|@wvw@d{pBsooApiN}|l@t~uBuc}@v{TqvkAfzhB"]
    },
    { "kind": "International boundary (verify)", "lines": ["cbhxFinh_C??wpn@|_pAmwrAtvZ_naAgyW"] },
    { "kind": "International boundary (verify)", "lines": ["s_z`G_eubC??boFrvj@jg]zirBt~f@jwG{r@dyW"] },
    { "kind": "International boundary (verify)", "lines": ["i{m~F}ot|B??kxeAncL{~R`vm@kls@nrh@"] },
    { "kind": "International boundary (verify)", "lines": ["}a}bG{`oyB??hhP|ps@{vc@blKbe_BvtsAtc}@ocL"] },
    { "kind": "International boundary (verify)", "lines": ["iohaGirmgCnaBr|tAdlJtnaA"] },
    { "kind": "International boundary (verify)", "lines": ["uzhdG{pszB??vwj@~nc@"] },
    { "kind": "International boundary (verify)", "lines": ["_wshGwrhtBtyP|nc@rkl@ho~@dmjBnr["] },
    { "kind": "International boundary (verify)", "lines": ["mwxpGg__sB{nhAcejAetv@r`}@_tjAjmn@"] },
    {
      "kind": "International boundary (verify)",
      "lines": ["ww|vHa_tzAbkSzcvAimUlor@vdd@h~o@nyd@hgkCdto@jogA~oi@b}lCn`y@iea@vjqAstSd}m@ctbBv}rA}gmB??"]
    },
    {
      "kind": "International boundary (verify)",
      "lines": ["iiiiHsm~qAt`yAxzcAhxWbdeAlg~B}tZde`@reQw~f@f|{@w~Dfs|Ap_b@fsjCiiGdgkDnpr@byZ}fu@nyaBtwIn}y@??"]
    },
    { "kind": "International boundary (verify)", "lines": ["ufaaH}zpy@}uz@xhpEtli@~ag@uj@xbeD"] },
    {
      "kind": "International boundary (verify)",
      "lines": ["arrgH{pofBg{c@f`yAlcIhvzAkrz@nrvCxqMxvcAx{nA~zlBuz}@jbpC"]
    },
    { "kind": "International boundary (verify)", "lines": ["{bvdHyisfB|xnAhyMhKz~lBrii@qyd@rv|B|y_A??"] },
    { "kind": "International boundary (verify)", "lines": ["kz}|Ggo{aBz}_@hfd@rzCfyiD~hk@rpaBecNpi`D"] },
    { "kind": "International boundary (verify)", "lines": ["azzzGoqgsAbe_BldT~crAexm@"] },
    {
      "kind": "International boundary (verify)",
      "lines": ["u{e}G}qv~@haoAvnNd}_@l`uAcnWtooChwmAthi@teEd`|Au}]dz`@vfaA`olBlhHjd}Ayyh@``sA"]
    },
    {
      "kind": "International boundary (verify)",
      "lines": ["s{saHijql@tj`@|rt@m~Pv~wAfsp@}gEbwlBzymCzlwAp{Air]kg|AxstA_bbA"]
    },
    {
      "kind": "International boundary (verify)",
      "lines": ["ssuwGoswh@??xdv@z`G~ihAonx@jnz@xubAdcvC_iq@xwWqzhBzwsA|iU"]
    },
    { "kind": "International boundary (verify)", "lines": ["is}pHah{c@??vjFb|q@hplBddT??"] },
    { "kind": "International boundary (verify)", "lines": ["gvhmHwesa@o`xAvziDveNhfcBsa{AphgCskmAvxyA}eBjxyA_ucA~g["] },
    { "kind": "International boundary (verify)", "lines": ["mrauHcnqd@@?yrl@tjjBuntAbszBnqg@~_tDuiNz~mC"] },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "azlwCvq`]joBf|iHl|iYkg}Al|iYig}AfaWyy`@|vgClmj@|}AztnW~lj@|h\\y}K`ojAzre@pcmBuku@pkgC|nCb||@|`rBvy_@frb@hv`A??"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": ["ezexAbbhiA}ceCj{_C_unC|duByvr@ps`Cclx@li|AncAx`lBbqi@ph~AqzOja`B|r}@b{aA"]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "gm~wDq~zx@hmkDyd~@|vyAsrIxi~Cxka@p`xAmbMt{iBbyWtxyBi`PxrpAlolAjjmCmnrB`urAuiFh|kBsmdAaxb@}hzAzvyAcdyC~hyByutA??"
      ]
    },
    { "kind": "International boundary (verify)", "lines": ["{hgnC_tfhApgsJhg|Svt~JxntP`bvAllrG"] },
    {
      "kind": "International boundary (verify)",
      "lines": ["og|sBmn`Y??|bRbtwEkg{BtfAow^hmyAmzv@~qxBsozAbmm@yciL|yqSwciL~yqS"]
    },
    { "kind": "International boundary (verify)", "lines": ["mlpjCqssyA|qgAndiCugjB~ylBuesA`~sH"] },
    { "kind": "International boundary (verify)", "lines": ["_{geC_yqwC~_eK?~Qnr_F`}pAblA"] },
    { "kind": "International boundary (verify)", "lines": ["}hovBkxnpCk}tJn~iWm}tJp~iWhxiBvddE"] },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "_g_cAatpjCth`@rszBbanAnabBhbtEpelCnnyAnyvDocKnr{Dt}Pnav@`wcAajR|gcAbzdBzfkA`}qAfviAh{tFgfk@lxo@eyB`j_@vfq@z~b@xtMjn`D"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "}qhl@ugg|A??a|s@{q]mseC`q|@gzoAjoZ_d`@hatAq~pB|grBid{Awli@xrRm_xA_|Lobv@d|@ualBkppDxhiBmv`CucFuq`Cr`Lea|B|slA"
      ]
    },
    { "kind": "International boundary (verify)", "lines": ["grnmAqenwApeJbcv@xd}@bhE"] },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "{eekAixpuAjxlAailAxgb@jhTf|_AxhIhcvCfpcDxs{Bzrr@lodBnpZxoj@xlh@`vgCflf@pmoAnmgBryaBjg]htmAzzj@xdpApgQ~x`AzdeCggoAvslBrfBf`iA~hqBpisBfw@hpw@bm{D~{{A`fiCxfq@"
      ]
    },
    { "kind": "International boundary (verify)", "lines": ["sg}jA`ygeA??l_Jhe[amNvniB~uT|sMtjCz`j@urn@hkkCm_Avg}A"] },
    {
      "kind": "International boundary (verify)",
      "lines": ["ymh}@bj_p@lcNb}e@vhaAztNdvoAs_l@dj{Cago@rnVnpgAzcZ~sQzud@uaN|dtAdoJbF`~]"]
    },
    {
      "kind": "International boundary (verify)",
      "lines": ["yd|m@nhor@??a_Dxfv@jsmApyf@m]~ev@grh@`_e@cmmA{{KisvB|spAn~Tl_r@jjCvuh@"]
    },
    {
      "kind": "International boundary (verify)",
      "lines": ["wyhr@dam}@??deJ`xt@orfAwdAmbr@zi^_xw@kiE_bqAtii@gzdArju@yEpe{Clxc@rol@bmCpyt@xbi@nj`@feu@boUzztAflgB"]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "wxbzAafhAx[df|Band@zvo@nxZzojBr_pAppuDx`|@ngd@rpvA`pvCpdq@fqYnwf@hzpAuiYlm}Ajtn@pot@`}dCdt[|z`Dd`zC`daAmoCdxqApgt@fkpB}|K??"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": ["eph~@bp~_@f}[vqoArsWjrl@aprAhf]t_Utkw@{xBbu`@z~w@h}b@qr@nyuCmi\\hau@zvPrmX"]
    },
    { "kind": "International boundary (verify)", "lines": ["{`{gAkxcLrky@nti@`gQdn~AnktA`xf@jbUldbA??"] },
    { "kind": "International boundary (verify)", "lines": ["i|bbAeunDmdCj`jD"] },
    {
      "kind": "International boundary (verify)",
      "lines": ["khzy@xfgPujq@ntdChlFlozA|bp@hicAsfh@hyvAar_Abca@uqi@ryvA"]
    },
    { "kind": "International boundary (verify)", "lines": ["wagbAysC??{pNriyAxo^~`~@ofM`huApeHrgrIxxmBzqCp`rCqsY??"] },
    {
      "kind": "International boundary (verify)",
      "lines": ["ckdfA}h`Up{_ArrFhzrBq|j@`smAnne@bps@mqS`|wBrv}A|zz@fd{@dezBdyc@vf{By|CpyyHleJ"]
    },
    { "kind": "International boundary (verify)", "lines": ["u{yLkov`BtmhBt`M_dm@`ezCgpr@j||CgtFfnuF??"] },
    { "kind": "International boundary (verify)", "lines": ["oxyL_{xnAosIbiWzcX|rrBadY|tuBryKhy{A??"] },
    { "kind": "International boundary (verify)", "lines": ["qrxLulycAqmChy|H"] },
    {
      "kind": "International boundary (verify)",
      "lines": ["ms{s@kqhpC`ktAqvsCp|mAi}iBhn~@ux@zudBcjbCjosA{kpAhdtBeip@jhlAq~pCh||@il^??"]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "gg}^_pafDdvSpn_A{nCjg|BspSr|qCpvO~qgAtnn@`h\\pzDzf~@eih@t`lAln`BdmxEyrRl_xAv`NjyYh}tBxky@{be@nupCifR~zmCo`gAzk{BckaA~u_Dt{}@pqgBbdbBj`kAxegC~pP"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": ["ey_wAmcj}EjvfDpb^pk_EdlnAjw_BrxtBjetCjwrA|ynA~rRnuu@ro{ArkkE|wx@??"]
    },
    {
      "kind": "International boundary (verify)",
      "lines": ["mxny@cchnE|qnDorAtsz@fe\\txC|sfB`gnBxoaAt~Le}vBde~Aq~aBfbmAcfa@`hl@kexAjpsEulrB"]
    },
    { "kind": "International boundary (verify)", "lines": ["}spkAgxnaGr}OkrrAqun@a|y@"] },
    {
      "kind": "International boundary (verify)",
      "lines": ["}cuaAezadG_ya@zij@dzL~_n@mgB~alBglz@zbBq|t@leN_qzA_aaA}juAgtcA"]
    },
    {
      "kind": "International boundary (verify)",
      "lines": ["npxDey|mE??y~mEj~@mcnAe}v@ch`Csb_BsjmCiafAke_Fn|tAs_aBzyUirfChr{A"]
    },
    {
      "kind": "International boundary (verify)",
      "lines": ["iklTqfe{Dix`Cf}jDilrAhkm@~hh@vwkBkzK~hyApx_@~gs@ytVhuvAuf`D|huB"]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "mmkTubsoB??r}tBpqJ~lgBzny@hzxBrde@ralDziWfumBafIvwbApy^dsfAzzCph}@dmUlc}A~q_CnrcBznxAnv|DbysAlu_DipE|n}@|jp@dk~AtwpB~kyBr|qB_ra@x}gAkhv@poK{|@pkiB~wiAhxaAs{R~hr@"
      ]
    },
    { "kind": "International boundary (verify)", "lines": ["~xd\\_einA??j`h@jafAxeq@r}^rctAxbEhsSrtp@"] },
    { "kind": "International boundary (verify)", "lines": ["b~dGufpsDbmu@hdw@ffsBvfFt`NhyY`ziBtaQ"] },
    { "kind": "International boundary (verify)", "lines": ["fpiPs|cpDpxwAubp@dqjFulK"] },
    { "kind": "International boundary (verify)", "lines": ["~{mZ_narD~trD_db@~pdB~oR~gpB_af@~jlB_hpB~auF_nhB"] },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "~{{q@_|rzDa{R~|kA~}_@~ieG~iVdjs@xt{B`tv@jcuAwuj@xffFfua@n`cErdWvva@ows@h_kAspgCkob@krt@nrqEoiOur@jntCqnjB`foAmfrA|}fAchZhttCajeBlyj@zs|@xkvBsfZvk{CytwAtg`Ao_Qn_{BzuC~ozAqu{@veJg|CrjbA"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "vcuaAkj}pCqoJp}wAxf\\l~wBgxCvzsAb|Pbjo@mlgFimIengA|c`A{bwBpiMkvtB{w[qjjA|qf@q{yBnqBru@n~kFujeAa_PjVpsbB|y`@zoIbsFjcxBfypBd_p@~yo@tg\\yqZp|jBlnZ`m_AjxN~c`C{beBnxiAgd~@n{k@wbtBr`w@kppCtdo@uqAbj_QtmVfocAssBrqw@`gYjroA"
      ]
    },
    { "kind": "International boundary (verify)", "lines": ["lmvMkb~xD??iwKxwfBnenBlxz@kjNnruB"] },
    { "kind": "International boundary (verify)", "lines": ["pr|EkftxDumVgocAboA}buEobNs}lK"] },
    { "kind": "International boundary (verify)", "lines": ["hziw@ai}fEssy@zymB}z_@zb{Bsu_@jzlAcvp@|qpA"] },
    { "kind": "International boundary (verify)", "lines": ["f{gtAsbviEh~_DvtoQd_jCeoQ"] },
    {
      "kind": "International boundary (verify)",
      "lines": ["vzs}Aa}wwD??rvYx|rCtxlAnenBxubAbwVtjNb|dAbs_DnzhDbl}BfdkB~oCj}`AeoUjm~@gkTnhyEerMvbb@"]
    },
    {
      "kind": "International boundary (verify)",
      "lines": ["rn}iBaeulCzqnAv}eJwsZ`zwMoq|AnifCvlG`vvWbvLzo\\aiwAbmsByyDvr}Bpg`@d|sB`dd@x~|A"]
    },
    {
      "kind": "International boundary (verify)",
      "lines": ["~pdkBshdwCt__@bboAtLzfz@rpkAvt{BkooAnsiAbkcAnclHrmEfkpC~uvTtwDvxEho_En`yP{@??"]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "xuyeCensrDvynCljsGxxpCfjnDxcaCn``A|jhA`vy@`sNngiBrm|Azia@t|{@hwRnnl@|{{B_tHz}}Cuuu@xh|AavV~hqApgl@|g~Arp|Atxn@fwy@tn{AbdvApt`Br|Rx{jCoqcAtqj@c_vB}~PqqxDjxrBsi\\hvs@"
      ]
    },
    { "kind": "International boundary (verify)", "lines": ["~~xfCmak}D??soRlyfBbmV~x`Awa`@|n}A}bAzmnA"] },
    { "kind": "International boundary (verify)", "lines": ["hmdbD}~vbE??uiuAzwOuqvAb|["] },
    { "kind": "International boundary (verify)", "lines": ["|ov|C}hiaE??iceAdtOsvxEkxa@swiChyq@k{qGjp|A"] },
    { "kind": "International boundary (verify)", "lines": ["}dukBdwa_P??uv[~o@{~GssVnbVmmb@u{tB{}dAgqAccd@"] },
    { "kind": "International boundary (verify)", "lines": ["{e`wAjyj`Pwqp@yqg@wie@bqNyod@cwLysu@gr{AgoiA__xA"] },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "oxsF~wdwKdaWpzc@uerBlae@i}|@fgu@pibAhr_AwjCnp{JxeyBklAfeSgmqBvxiAhrEseSv`f@jd_@v~lB`|lCx^hgfAksuA|ynBsq]lusAnrCvovOrxvA??"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "pnfYdbriLoyfBrv`BgsCliy@mweEc~|B}mzA~ptCbxO`ftBix`@bpeApsr@xrjB_nWzlpCwwkE|`rBkiq@`lyAce{A~i}@go{Al{`CxoQfas@??"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": ["bu\\ti`kM_gm@lsrAku_Axz~Ana^lnv@kbZxvdDy_sAtqn@~bBdlc@{onBjjbE"]
    },
    {
      "kind": "International boundary (verify)",
      "lines": ["nrwiCvwqxK??bwYj|kC_glGhokAmazEz|gBm~{Dmo|@kuqAvmeBs|kC~`YsycCnv~A"]
    },
    {
      "kind": "International boundary (verify)",
      "lines": ["nwczB|r_bJ{e{@viBc|bBh}tDmwAhjtDtyw@hksId{jDrt|Ax`hBp|CtzhFv|kA"]
    },
    {
      "kind": "International boundary (verify)",
      "lines": ["leb|C`_llI??{ld@iv_BzvoBs~`Bl~zCn~BdtjBjmcD~onAfdbCtr|Dxl{EbiiG|qcG"]
    },
    {
      "kind": "International boundary (verify)",
      "lines": ["zrlwD~{u~I??kyS}w}Br`vCkzbEmuDgrgAbc|Bs~gEl}jBcfxCp{cCw}oBxs{A|buArrmBqau@"]
    },
    {
      "kind": "International boundary (verify)",
      "lines": ["brhjBb{vgL{xqEiezBodcDf_sAat`Ayxk@elgAx~a@gq`BqhkAqeeDyyBmhhCgrHabaAs~h@akyHvzgD"]
    },
    { "kind": "International boundary (verify)", "lines": ["evvqA}hhpA??nytE}ccCeiCmic@??"] },
    { "kind": "International boundary (verify)", "lines": ["}{{lHigwd@dcCljw@o}Obuj@"] },
    {
      "kind": "International boundary (verify)",
      "lines": ["osmkFqlsxGy}Xr}dCgdyApsaButhA|~]", "gkskFyczzG_boC}ieFylMwfhAhix@mux@bs_BxibAvgeBqxxBwvHwro@"]
    },
    { "kind": "International boundary (verify)", "lines": ["ufykA~zrrA??meG`}gJv~Tljs@chExt_A`y^tmfB"] },
    {
      "kind": "International boundary (verify)",
      "lines": ["rmdvCo{lxBhjpUjEvzbBvimDngMv|gB{|c@txyBgfMbsvAmorAj|_@ent@nclAxq_B`q|A"]
    },
    {
      "kind": "International boundary (verify)",
      "lines": ["loxfCpdr}J??wxh@|o^oaGfv}E~b|CrekAealCbyqBaqn@zp~FpnoDjwaD"]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "b_zaAp_kgL??bpOafpCsgCgqcBeaz@aqj@{cnA}wiD}ihAa|eBia`@}p~F`kqC~wSrajAm_Wh}aCjuNd}mD_bsEnf_@avyEd~gAazkAbue@{_cCfvw@qyoAk|@{zyBr|x@ampBr{oBurGx_x@}`e@jfsAkqAhgBx~w@flbFqbjA`aGkmuJtxoBxt[balAi}S~yu@cuiBrlxBacm@zyxCbua@lqtAnot@pinBixQ??|jg@v`|@",
        "pk{xBdqb`J|jg@v`|@"
      ]
    },
    { "kind": "Indefinite (please verify)", "lines": ["qnx~EurfnMpauCqxx@hvTwjwA"] },
    { "kind": "Disputed (please verify)", "lines": ["afkhEqnmbN??lvbBxkE??"] },
    { "kind": "International boundary (verify)", "lines": ["sngeEwagbN_gYpdkC|rcAwmP"] },
    { "kind": "Disputed (please verify)", "lines": ["ub}cE}jl~MbzoAiqS"] },
    { "kind": "International boundary (verify)", "lines": ["qglaEg}`_Ndy`A{vOrpPofZ"] },
    { "kind": "Disputed (please verify)", "lines": ["w{x~Ds|l`Nzz|@___B"] },
    { "kind": "International boundary (verify)", "lines": ["{_{|Ds|lcNxfk@yscA|wGmmP"] },
    { "kind": "Disputed (please verify)", "lines": ["c_f{D{_cfNx_k@iovA"] },
    { "kind": "International boundary (verify)", "lines": ["i~yyDepzhNnwrA_oeD??"] },
    { "kind": "Disputed (please verify)", "lines": ["qbluGqm__F~ypAxbWhgo@}`K"] },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "whkkH_oetOw`OqlkAvggCygr@~qfB}ccD`jhA_suGzh|CeweCpecFlejAjusAogeArk`@ibgFngZo`fGtuxBq~jFxtTcuwBt`sDq~wAj~rBasqBkpCwhvEfxj@qcrKqdZowbGza\\ay_EfsuBk|_HoDiikFjv{@anuAuzgB}kbF}xbAqozHalF{vcHsucAafcFqrgByckCyt`AougCym_A|r^y`jAtj}@y{|B{oeBdtPg|lBbrf@}vgEiufBuraEctjAwxhHcb`CubnCiqv@gnhCg|XquzGp_U}ayCeldAwkTsogCt~oD_m}@pv{CjagAzbuCcl]bu_EzwW~pmBeznArhq@cdbEk~hCggrCwb~A??"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "oznoHkycgU??vvhA{miFglzBmfrGg}tAnw@}cnEyhoDor}@wrkByyjBtlAmlm@ddjBid`Bii`Dafb@yuqFehDu|aG|cy@sicHn|fAqojDl~cEyuwBx`sA_ehA~|vB{_cA`i~DeggA~l}@s|rIbziC}ifFhovDabnAhFmwgHo`lA_ihDoqx@uxaItvnDlseBfnfAzzjAh~tEx|aAd_}DjjbCwqa@p`lFp~cA`sfDxgfDgmr@nweFdb[rgDxwbB`fbBke@"
      ]
    },
    { "kind": "Indefinite (please verify)", "lines": ["u|_jE{{~wEdfa@p~PuJnj`A"] },
    { "kind": "Line of control (please verify)", "lines": ["kserEevriMcg[|tnDzesAfw~AncjD{edAnccCmybA"] },
    { "kind": "Line of control (please verify)", "lines": ["cb}tEm|vvMlylA`|pAz_\\xuxEqkRjqwB"] }
  ]
}
